/*
  Save For Later buttons on the cart page.

  Swym attaches its SaveForLater API asynchronously, so the buttons stay hidden
  until the 'swym:sfl-ready' event fires from the swym-custom snippet. On success
  the line item is removed by navigating to the cart change URL, which redirects
  back to the cart and reloads the page.
*/
const cartPageCanonicalUrl = (url) => {
  if (!url) return ''

  try {
    const parsed = new URL(url, window.location.origin)
    parsed.search = ''
    parsed.hash = ''
    return parsed.href
  } catch (err) {
    return url
  }
}

const cartPageSaveForLater = {
  init () {
    this.buttons = Array.from(document.querySelectorAll('[data-cart-page-save-for-later]'))
    if (this.buttons.length === 0) { return }

    this.setReady()
    document.addEventListener('swym:sfl-ready', () => { this.setReady() }, { once: true })

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => { this.saveForLater(button) })
    })
  },

  setReady () {
    const isReady = Boolean(window._swat?.sflLid)
    this.buttons.forEach(button => button.classList.toggle('is-ready', isReady))
  },

  saveForLater (button) {
    const swat = window._swat
    if (!swat?.SaveForLater || !swat.sflLid) {
      console.warn('Swym Save For Later is not ready', {
        api: Boolean(swat?.SaveForLater),
        listId: swat?.sflLid
      })
      return
    }

    button.disabled = true

    // Swym validates epi/empi/du synchronously and throws when any are missing
    // or when du is not an absolute URL.
    try {
      swat.SaveForLater.add(
        swat.sflLid,
        [{
          du: cartPageCanonicalUrl(button.getAttribute('data-product-url')),
          empi: parseInt(button.getAttribute('data-product-id'), 10),
          epi: parseInt(button.getAttribute('data-variant-id'), 10),
          qty: parseInt(button.getAttribute('data-quantity'), 10)
        }],
        (response) => {
          const failed = response?.itemsfailed || []
          if (failed.length > 0 && (response?.itemsadded || []).length === 0) {
            console.error('Swym Save For Later add failed', response)
            button.disabled = false
            return
          }
          window.location.href = button.getAttribute('data-remove-url')
        },
        (err) => {
          console.error('Swym Save For Later add failed', err)
          button.disabled = false
        }
      )
    } catch (err) {
      console.error('Swym Save For Later add failed', err)
      button.disabled = false
    }
  }
}

cartPageSaveForLater.init()
